/**
 * Created by jhcao on 2020/05/28.
 * 会员相关接口
 */
import 'babel-polyfill'
import { config } from 'config'

/**
 * 获取会员等级
 */
function getMemberLevel () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/level/get',
      type: 'get',
      cache: false,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}
/**
 * 查询用户等级权益
 */
function getMemberBenefit () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/level/get-benefit',
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}
/**
 * 查询用户等级子权益
 */
function getMemberLevelBenefit (id) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/level/get-level-benefit?benefitId=' + id,
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}
/**
 * 查询用户总金额和总调用量和调用天数
 */
function getLevelNum () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/level/get-level-num',
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 领取等级权益
 */
function getLevelEquity (inputData) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/level/use',
      type: 'post',
      data: inputData,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  getMemberLevel,
  getMemberBenefit,
  getMemberLevelBenefit,
  getLevelNum,
  getLevelEquity
}



// WEBPACK FOOTER //
// ./src/js/api/member.js